import { render, staticRenderFns } from "./CommentBlock.vue?vue&type=template&id=08a15eac&scoped=true"
import script from "./CommentBlock.vue?vue&type=script&lang=js"
export * from "./CommentBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a15eac",
  null
  
)

export default component.exports